import {fetchBaseQuery} from '@reduxjs/toolkit/dist/query';
import {environment} from '@vin-decoder/environment';

export const vinDecoderBaseQuery = fetchBaseQuery({
  baseUrl: environment.VIN_DECODER_URL,
});
